import { isIos, isAndroid } from '@app/utils'

import { GenericBanner } from './components/GenericBanner'
import { IosBannerHeader } from './components/IosBannerHeader'
import { isSafari } from './helpers'


export const AppSmartBanner = () => {
  if (!isIos() && !isAndroid()) {
    return null
  }

  return (
    <>
      {isIos() && isSafari() ? (
        <IosBannerHeader />
      ) : null}
      {isIos() && !isSafari() || isAndroid() ? (
        <GenericBanner />
      ) : null}
    </>
  )
}

